import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { HttpRequestInterceptorModule } from './core/interceptors/request-interceptor.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { SignOutComponent } from './authentication/sign-out/sign-out.component';
import { ErrorHandlerService } from './core/services/error-handler.service';
import { AppInsightsService } from './core/services/appinsight.service';
import { ConfirmBoxModule } from './shared/components/confirm-box/confirm-box.module';
import { ConfirmService } from './shared/components/confirm-box/confirm-box.service';

@NgModule({
  declarations: [
    AppComponent,
    SignOutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpRequestInterceptorModule,
    BrowserAnimationsModule,
    NgHttpLoaderModule.forRoot(),
    ConfirmBoxModule
  ],
  providers: [AppInsightsService,
    { provide: ErrorHandler, useClass: ErrorHandlerService }],
  bootstrap: [AppComponent]
})
export class AppModule { }
